import * as angular from 'angular';
import {IController} from 'angular';
import {UserService} from "../../../../permission/user.service";

export class AdminAutocompleteInputComponent implements IController {

  adminId: string;
  admin: any;
  searchQuery: string;
  label: any;
  isRequired: boolean;
  isDisabled: boolean;
  onSelect: Function;
  onClear: Function;

  public adminItem: any;
  public items: any[];

  constructor(private UserService: UserService) {
  }

  $onInit() {
    if (!this.searchQuery) {
      this.searchQuery = null;
    }
    if (!this.label) {
      this.label = 'Search For Admin';
    }

    if (!!this.adminId) {
      this.UserService.getUsers([this.adminId])
        .then((admins) => {
          this.adminItem = admins[0];
        })
    }
  };

  searchChanged(searchQuery) {
    this.onClear();
    if (!!searchQuery) {
      this.onSearch(searchQuery);
    }
  }

  // accountNameFilter(account: AccountModel) {
  //   const name = this.$filter('userName')(a.user);
  //   return account.name;
  // }

  onSearch(query) {

    this.UserService.getUsers(undefined, query)
      .then((admins) => {
        this.items = admins;
      })
  }

  onSelectItem(item) {
    if (this.adminId === item?.id) {
      return;
    } else {
      this.adminId = item?.id;
      this.adminItem = item;
      this.onSelect({admin: item, adminId: item?.id});
    }
  }

}

angular
  .module('bringoz.admin.admins')
  .component('adminAutocompleteInput', {
    bindings: {
      adminId: '<?',
      searchQuery: '<?',
      label: '<?',
      noCache: '<',
      isRequired: '<?',
      isDisabled: '<?',
      onSelect: '&',
      onClear: '&',
    },
    template: require('./admin-autocomplete-input.html').default,
    controller: AdminAutocompleteInputComponent
  });
